<form *ngIf="set" class="flex flex-col gap-1" [formGroup]="form">
  <ng-container *ngFor="let assignment of orderedAssignments">
    <ng-container *ngIf="assignment.kind === 'PROPERTY'" [formGroup]="propertyValuesForm">
      <ng-container *ngIf="showHidden || !assignment.propertyAssignment.hidden">
        <div *ngIf="isVinDecodeField(assignment.propertyAssignment); else propertyField" class="flex items-start gap-2">
          <!-- The form field renders its input as a sibling of its host, so the wrapper has to take the width. -->
          <div class="flex flex-col flex-1 min-w-0">
            <ng-container *ngTemplateOutlet="propertyField"></ng-container>
          </div>
          <button
            vs-button
            type="button"
            class="mt-7 min-w-fit"
            theme="primary"
            vsTooltip="Autofill Vehicle information from VIN"
            [disabled]="disabled || decodingVin || !vinDecodeValue"
            (click)="useVIN()"
          >
            <vs-icon name="file-06"></vs-icon>
          </button>
        </div>

        <ng-template #propertyField>
          <vs-property-input-form-field
            [property]="assignment.propertyAssignment.property!"
            [hidden]="assignment.propertyAssignment.hidden"
            [showHidden]="showHidden"
            [autoVinLookup]="true"
            [order]="assignment.order"
            [formControlName]="assignment.propertyAssignment.property!.valueKey"
            [required]="assignment.propertyAssignment.required"
            [extraData]="extraData"
          >
          </vs-property-input-form-field>
        </ng-template>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="assignment.kind === 'DIMENSION'" [formGroup]="dimensionValuesForm">
      <vs-dimension-input-form-field
        *ngIf="assignment.dimensionAssignment.dimension && (showHidden || !assignment.dimensionAssignment.hidden)"
        [dimension]="assignment.dimensionAssignment.dimension"
        [hidden]="assignment.dimensionAssignment.hidden"
        [showHidden]="showHidden"
        [order]="assignment.order"
        [formControlName]="assignment.dimensionAssignment.dimensionId"
        [required]="assignment.dimensionAssignment.required"
      >
      </vs-dimension-input-form-field>
    </ng-container>
  </ng-container>
</form>
